<script lang="ts" setup>
import { computed } from 'vue'
import JyHeader from 'components/header/index.vue'
import JyNav from 'components/nav/index.vue'
import { commonStore } from '@/stores/common'
import { useUserStore } from '@/stores/user'
const common = commonStore()

const user = useUserStore()
const appName = __APP__NAME
const includeComponents = ['Ota']

</script>

<template>
  <el-container class="jy-layout">
    <el-header>
      <jy-header :app-name="appName" :user="user" />
    </el-header>
    <el-main>
      <el-container class="jy-layout-main-container">
        <el-aside v-if="common.isShowMenu">
          <jy-nav :permission-list="common.permissionList || []" :active-resource-url="common.activeResourceUrl" />
        </el-aside>
        <el-main class="jy-layout-main-content">
          <!-- 使用 router-view 的插槽，获取当前路由的组件和路由信息 -->
          <router-view v-slot="{ Component, route: routeData }">
            <!-- 如果路由配置了 KeepAlive，则使用 keep-alive 包裹组件进行缓存 -->
            <keep-alive :include="includeComponents">
              <component :is="Component" :key="routeData.fullPath" />
            </keep-alive>
          </router-view>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>

<style lang="scss">
.jy-layout {
  .el-header {
    padding: 0;
  }

  .el-main {
    padding: 0;

    .jy-layout-main-container {
      height: calc(100vh - 60px);
    }

    .el-aside {
      width: 240px;
      height: 100%;
    }

    .jy-layout-main-content {
      padding: 0 10px 10px;
    }
  }
}
</style>
